import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft, Home } from "lucide-react";
import { Button } from "@/components/ui/button";
import auraLogo from "@/assets/aura-logo.png";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="text-center max-w-md">
        {/* Logo */}
        <div className="mb-8">
          <img src={auraLogo} alt="AURA" className="w-20 h-20 mx-auto mb-4" />
        </div>
        
        {/* 404 Title */}
        <h1 className="font-serif text-8xl font-light mb-2 text-foreground">404</h1>
        <p className="text-[10px] tracking-[0.4em] uppercase text-muted-foreground mb-6">
          Page Not Found
        </p>
        
        {/* Description */}
        <p className="text-muted-foreground mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved. 
          Let's get you back to curating.
        </p>
        
        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild>
            <Link to="/" className="gap-2">
              <Home size={16} />
              Return Home
            </Link>
          </Button>
          <Button variant="outline" onClick={() => window.history.back()} className="gap-2">
            <ArrowLeft size={16} />
            Go Back
          </Button>
        </div>
        
        {/* Footer */}
        <p className="mt-12 text-[9px] tracking-[0.2em] uppercase text-muted-foreground">
          AURA — The Curation of Self
        </p>
      </div>
    </div>
  );
};

export default NotFound;
